var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Mutation, State } from 'vuex-simple';
var SteppedPageModule = /** @class */ (function () {
    function SteppedPageModule(root) {
        this.root = root;
        this.step = 'D';
        this.item = {};
        this.validationRules = {};
    }
    SteppedPageModule.prototype.setStep = function (step) {
        this.step = step;
    };
    SteppedPageModule.prototype.setItem = function (item) {
        this.item = item;
    };
    SteppedPageModule.prototype.setValidationRules = function (value) {
        this.validationRules = value;
    };
    var _a;
    __decorate([
        State(),
        __metadata("design:type", String)
    ], SteppedPageModule.prototype, "step", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], SteppedPageModule.prototype, "item", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], SteppedPageModule.prototype, "validationRules", void 0);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SteppedPageModule.prototype, "setStep", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof T !== "undefined" && T) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], SteppedPageModule.prototype, "setItem", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SteppedPageModule.prototype, "setValidationRules", null);
    return SteppedPageModule;
}());
export { SteppedPageModule };
